import { request_detail, request_list, update_detail, create_detail, remove_detail } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice, refreshResource } from '@/commons/utils';
import Vue from 'vue';
const endpoint = 'users'
const viewTitle = 'nhân viên'

// initial state
const state = {
    loading: false,
    all: {},
    selected: {
        ID: 0,
        Username: '',
        Email: '',
        RoleType: 0,
        IsSaleLeader: 0,
        SaleLeaderID: null,
        is_active: 0,
        is_admin: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setDetail', data);
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setDetail({ commit }, {data, id, notify = ''}) {
        return new Promise((resolve, reject) => {
            if(id > 0) {
                data.ModifiedBy = this.state.authentication.user.username;
                update_detail(endpoint, res => {
                    if (res.data.status === 'fail') {
                        sendErrorNotice(`Không thể cập nhật ${viewTitle}.`)
                        reject(res);
                    }
                    else {
                        sendSuccessNotice(notify == '' ? `Cập nhật ${viewTitle} thành công.` : notify);
                        refreshResource();
                        resolve(res);
                    }
                }, Vue.http, data, id, this.state.authentication.token);
            }
            else {
                data.CreatedBy = this.state.authentication.user.username;
                delete data.ID;
                create_detail(endpoint, res => {
                    if (res.data.status === 'fail') {
                        sendErrorNotice(`Không thể thêm mới ${viewTitle}.`)
                        reject(res);
                    }
                    else {
                        sendSuccessNotice(`Thêm mới ${viewTitle} thành công. Mật khẩu 123456.`);
                        refreshResource();
                        resolve(res);
                    }
                }, Vue.http, data, this.state.authentication.token);
            }
        });
    },
    removeDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice(`Không thể xóa ${viewTitle}.`)
            }
            else {
                sendSuccessNotice(`Đã xóa ${viewTitle} thành công.`)
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
